<template>
  <div class="container beforeApril">
    <div id="ImageExportDom">
      <div class="titleBox">
        <p class="title">{{party_a_data.party_a_name.value}}结算单</p>
        <p v-if="statement_id" class="xlh" style="left:0">（04之前）序列号：{{statement_id}}</p>
        <p v-if="dataInfo&&dataInfo.applicant_time" style="top:30px;left:0" class="xlh">申请时间：{{dataInfo.applicant_time}}</p>
        <div class="xlh" style="top:30px" v-if="statement_id">{{dataInfo.verify_status == 1?'商务待审核':dataInfo.verify_status == 2?'财务待审核':dataInfo.verify_status == 3?'商务驳回':dataInfo.verify_status == 4?'财务审核通过':dataInfo.verify_status == 5?'财务驳回':''}}</div>
      </div>
      <div class="table_container" v-if="editFlag">
        <table>
          <tr>
            <th v-for="(item,index) in table_data" :key="index">{{item.name}}</th>
          </tr>
          <tr v-for="(items,index_main) in order_data" :key="index_main">
            <td v-for="(item,index) in items" :key="index">
              <el-date-picker v-if="item.type=='month'" class="input" style="width:100px" v-model="item.value" size="mini" type="month" value-format="yyyy-MM" :picker-options="pickerOptionsMonth" placeholder="选择月">
              </el-date-picker>
              <el-input class="input" v-if="item.type=='number'" v-model="item.value" :placeholder="item.name" @input="(val)=>{clearNoNum({value:val,index:index_main,valueName:index,mainName:'order_data'})}" size='mini'></el-input>
              <el-input class="input" v-if="item.type=='text'" v-model="item.value" :placeholder="item.name" size='mini'></el-input>
              <el-date-picker v-if="item.type=='date'" class="input" v-model="item.value" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
              <img v-if="item.type=='delete'" src="@/assets/img/delete_icon.png" @click="deleteOrder(index_main)" class="add_icon" style="margin:0px;width:16px;height:16px" alt="">
            </td>
          </tr>
          <tr>
            <td colspan='9' style="border:none">
              <img src="@/assets/img/add_icon.png" @click="addOrder" class="add_icon" alt="">
            </td>
          </tr>
        </table>
        <div>
          <label style="color: #262c57;font-size: 14px;">开票客户名称：</label>
          <span>{{customer_name}}</span>
        </div>
      </div>
      <div class="table_container table_container2" v-else>
        <table v-if="order_list&&order_list.list">
          <tr>
            <th>月份</th>
            <th>销售人员</th>
            <th>项目名称</th>
            <th>投放平台</th>
            <th>媒体名称</th>
            <th>订单金额</th>
            <th>订单最终收入金额</th>
            <th>开票次数</th>
            <th>开票金额</th>
          </tr>
          <template v-for="(item1,indexs) in order_list.list">
            <tr v-for="(items,index_main) in item1.row" :key="index_main+'in_main' + indexs">
              <td>{{items.order_month}}</td>
              <td>{{items.saleman}}</td>
              <td>{{items.project_name}}</td>
              <td>{{items.platform_name}}</td>
              <td>{{items.media_name}}</td>
              <td style="text-align:right">{{$formatNum(items.amount)}}</td>
              <td style="text-align:right">{{$formatNum(items.final_amount)}}</td>
              <td>{{items.invoice_num}}</td>
              <td style="text-align:right">{{$formatNum(items.invoice_amount)}}</td>
            </tr>
            <tr :key="indexs+'main'" style="background:rgb(244, 247, 250)">
              <td colspan='5'>小计</td>
              <td style="text-align:right">{{$formatNum(item1.amount)}}</td>
              <td style="text-align:right">{{$formatNum(item1.final_amount)}}</td>
              <td></td>
              <td style="text-align:right">{{$formatNum(item1.invoice_amount)}}</td>
            </tr>

          </template>
          <tr>
            <td colspan='5'>总金额</td>
            <td style="text-align:right">{{$formatNum(order_list.total.amount)}}</td>
            <td style="text-align:right">{{$formatNum(order_list.total.final_amount)}}</td>
            <td></td>
            <td style="text-align:right">{{$formatNum(order_list.total.invoice_amount)}}</td>
          </tr>
        </table>
        <div>
          <label style="color: #262c57;font-size: 14px;">开票客户名称：</label>
          <span>{{dataInfo.customer_name}}</span>
        </div>
      </div>
      <div class="statementToast">
        <div class="bothSidesBox clear">
          <div class="aParty">
            <div class="title">甲方银行账号信息如下：</div>
            <div v-if="editFlag">
              <div class="infoItem">
                <label>账户名称：</label>
                <el-select class="input" v-model="party_a_data.party_a_name.value" size='mini' filterable placeholder="账户名称" @change="(val)=>{party_a_change(val)}">
                  <el-option v-for="(item,index) in customerList" :key="index" :label="type==2?item.name:item.customer_name" :value="type==2?item.name:item.customer_name">
                  </el-option>
                </el-select>
              </div>
              <div class="infoItem">
                <label>税号：</label>
                <span>{{party_a_data.party_a_ein.value}}</span>
              </div>
              <div class="infoItem">
                <label>银行/账号：</label>
                <span>{{party_a_data.party_a_account.value}}</span>
              </div>
              <div class="infoItem">
                <label>地址/电话：</label>
                <span>{{party_a_data.party_a_address.value}}</span>
              </div>
              <div class="infoItem" style="margin-top:20px">
                <label>签字盖章：</label>
              </div>
              <div class="infoItem">
                <label>联系人：</label>
                <el-input class="input" v-model="party_a_data.party_a_contact.value" size='mini' placeholder="请输入联系人"></el-input>
              </div>
              <div class="infoItem">
                <label>联系电话：</label>
                <el-input class="input" v-model="party_a_data.party_a_phone.value" size='mini' placeholder="请输入联系电话"></el-input>
              </div>
              <div class="infoItem">
                <label>日期：</label>
                <el-date-picker style="width:160px" v-model="party_a_data.party_a_add_date.value" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="日期">
                </el-date-picker>
              </div>
              <!-- <div class="infoItem" v-for="(item,index) in party_a_data" :key="index">
                <label>{{item.name}}：</label>
                <el-date-picker v-if="item.type=='month'" class="input" v-model="item.value" size="mini" type="month" value-format="yyyy-MM" :picker-options="pickerOptionsMonth" placeholder="选择月">
                </el-date-picker>
                <el-input class="input" v-if="item.type=='number'" v-model="item.value" :placeholder="item.name" @input="(val)=>{clearNoNum({value:val,valueName:index,mainName:'party_a_data'})}" size='mini'></el-input>
                <el-input class="input" v-if="item.type=='text'" v-model="item.value" :placeholder="item.name" size='mini'></el-input>
                <el-date-picker v-if="item.type=='date'" class="input" v-model="item.value" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="选择日期">
                </el-date-picker>
              </div> -->
            </div>
            <div v-else>
              <div class="infoItem" v-for="(item,index) in party_a_data" :key="index">
                <label>{{item.name}}：</label>
                <div class="inputDiv">{{dataInfo[index]}}</div>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
            </div>
          </div>
          <div class="aParty">
            <template v-if="editFlag">
              <div class="title">乙方银行账号信息如下：</div>
              <div class="infoItem">
                <label>账号名称：</label>
                <el-input class="input" v-model="party_b_data.company.value" placeholder="请输入乙方账户名称" size='mini'></el-input>
              </div>
              <div class="infoItem">
                <label>开户银行：</label>
                <el-select class="input" v-model="party_b_data.bank.value" size='mini' filterable placeholder="开户银行" @change="(val)=>{party_b_data.account.value = partyBAccountList.filter((v)=>{return v.bank == val})[0].account}">
                  <el-option v-for="(item,index) in partyBAccountList" :key="index" :label="item.bank" :value="item.bank">
                  </el-option>
                </el-select>
              </div>
              <div class="infoItem">
                <label>账户：</label>
                <div class="inputDiv">{{party_b_data.account.value}}</div>
              </div>

              <div class="infoItem" style="margin-top:40px">
                <label>签字盖章：</label>
              </div>
              <div class="infoItem">
                <label>联系人：</label>
                <el-input class="input" v-model="party_b_data.party_b_contact.value" size='mini' placeholder="请输入联系人"></el-input>
              </div>
              <div class="infoItem">
                <label>联系电话：</label>
                <el-input class="input" v-model="party_b_data.party_b_phone.value" size='mini' placeholder="请输入联系电话"></el-input>
              </div>
              <div class="infoItem">
                <label>日期：</label>
                <el-date-picker style="width:160px" v-model="party_b_data.add_date.value" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="日期">
                </el-date-picker>
              </div>
            </template>
            <div v-else>
              <div class="infoItem" v-for="(item,index) in party_b_data" :key="index">
                <label>{{item.name}}：</label>
                <div class="inputDiv">{{dataInfo[index]}}</div>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
            </div>
          </div>
          <!-- <div class="aParty">
            <div class="title">乙方银行账号信息如下：</div>
            <div v-if="editFlag">
              <div class="infoItem" v-for="(item,index) in party_b_data" :key="index">
                <label>{{item.name}}：</label>
                <el-date-picker v-if="item.type=='month'" class="input" v-model="item.value" size="mini" type="month" value-format="yyyy-MM" :picker-options="pickerOptionsMonth" placeholder="选择月">
                </el-date-picker>
                <el-input class="input" v-if="item.type=='number'" v-model="item.value" :placeholder="item.name" @input="(val)=>{clearNoNum({value:val,valueName:index,mainName:'party_b_data'})}" size='mini'></el-input>
                <el-input class="input" v-if="item.type=='text'" v-model="item.value" :placeholder="item.name" size='mini'></el-input>
                <el-date-picker v-if="item.type=='date'" class="input" v-model="item.value" type="date" size="mini" value-format="yyyy-MM-dd" placeholder="选择日期">
                </el-date-picker>
              </div>
            </div>
            <div v-else>
              <div class="infoItem" v-for="(item,index) in party_b_data" :key="index">
                <label>{{item.name}}：</label>
                <div class="inputDiv">{{dataInfo[index]}}</div>
              </div>
              <div class="infoItem">
                <label>签字盖章：</label>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="verify_opinion" v-if="editFlag">
      <add-file @file='(val)=>{uploadFile=val}' :fileOtherList='fileList' :uploadOtherFile='uploadFile'></add-file>
    </div>
    <div class="verify_opinion">
      <label style="vertical-align: top;">附件</label>
      <div v-if="uploadFile.length!=0" style="display:inline-block">
        <div v-for="(item,index) in uploadFile" :key="index" class="flexBox">
          <div class="enclosure" @click="lookFile(item)">
            <i class="el-icon-search"></i>
            <span>{{item&&item.split('/')&&item.split('/')[item.split('/').length-1]?item.split('/')[item.split('/').length-1]:'附件'}}</span>
          </div>
          <div class="enclosure" @click="downLoadFiles(item)" style="margin-left:10px">
            <i class="el-icon-download"></i>
            <span>下载附件</span>
          </div>
        </div>
      </div>
    </div>
    <div class="verify_opinion no-print">
      <div class="item" v-if="dataInfo.verify_status&&dataInfo.verify_status!=1">
        <div style="margin:5px 0">
          <label>商务审核人：</label>
          <span class="verifySpan">{{dataInfo.verify_user}}</span>
        </div>
        <div style="margin:5px 0">
          <label>商务审核时间：</label>
          <span class="verifySpan">{{dataInfo.verify_time}}</span>
        </div>
        <div style="margin:5px 0">
          <label>商务审核备注：</label>
          <span class="verifySpan">{{dataInfo.verify_opinion}}</span>
        </div>
      </div>
      <div class="item" v-if="dataInfo.verify_status==4||dataInfo.verify_status==5">
        <div style="margin:5px 0">
          <label>财务审核人：</label>
          <span class="verifySpan">{{dataInfo.confirm_verify_user}}</span>
        </div>
        <div style="margin:5px 0">
          <label>财务审核时间：</label>
          <span class="verifySpan">{{dataInfo.confirm_verify_time}}</span>
        </div>
        <div style="margin:5px 0">
          <label>财务审核备注：</label>
          <span class="verifySpan">{{dataInfo.confirm_verify_opinion}}</span>
        </div>
      </div>
      <div class="item" v-if="(dataInfo.verify_status == 1 &&userInfo.role_id==15)|| (dataInfo.verify_status == 2&&userInfo.role_id==10)">
        <label>审核备注：</label>
        <el-input class="textarea" type="textarea" placeholder="请输入审核原因" v-model="reason">
        </el-input>
      </div>
    </div>
    <div slot="footer" style="text-align: center;margin-top:40px">
      <!-- 商务审核 -->
      <div v-if="userInfo.role_id == 15">
        <el-button type="primary" size='small' @click="examineSubmit(2)" v-if="dataInfo.verify_status == 1">审核通过</el-button>
        <el-button type="primary" size='small' @click="examineSubmit(3)" style="background:#d51313;border-color:#d51313" v-if="dataInfo.verify_status == 1">审核不通过</el-button>
        <el-button size='small' @click="printDOM">导出</el-button>
      </div>
      <!-- 财务 -->
      <div v-else-if="userInfo.role_id == 10">
        <el-button type="primary" size='small' @click="examineSubmit(4)" v-if="dataInfo.verify_status == 2">审核通过</el-button>
        <el-button type="primary" size='small' @click="examineSubmit(5)" style="background:#d51313;border-color:#d51313" v-if="dataInfo.verify_status == 2">审核不通过</el-button>
        <el-button size='small' @click="printDOM">导出</el-button>
      </div>
      <!-- 其他 -->
      <div v-else>
        <el-button v-if="editFlag" type="primary" size='small' @click="editStatement()">提 交</el-button>
        <el-button size='small' @click="printDOM">导出</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import addFile from '@/components/assembly/addFile'
export default {
  components: {
    addFile
  },
  props: ['type', 'statement_id', 'statement_status'],
  data () {
    return {
      table_data: {
        order_month: { id: 1, value: '', type: 'month', name: '月份' },
        saleman: { id: 2, value: '', type: 'text', name: '销售人员' },
        project_name: { id: 4, value: '', type: 'text', name: '项目名称' },
        platform_name: { id: 5, value: '', type: 'text', name: '投放平台', noMust: true },
        media_name: { id: 6, value: '', type: 'text', name: '媒体名称', noMust: true },
        amount: { id: 7, value: '', type: 'number', name: '订单金额' },
        final_amount: { id: 8, value: '', type: 'number', name: '订单最终收入金额' },
        invoice_num: { id: 9, value: '', type: 'number', name: '开票次数' },
        invoice_amount: { id: 10, value: '', type: 'number', name: '开票金额' },
        delete: { id: 11, value: '', type: 'delete', name: '', noMust: true },
        // customer_name:{id:12, value:'', type:'text', name:'开票客户名称'},
      },
      party_a_data: {
        party_a_name: { value: '', type: 'text', name: '甲方账户名称' },
        party_a_ein: { value: '', type: 'text', name: '甲方税号' },
        party_a_account: { value: '', type: 'text', name: '甲方银行/账号' },
        party_a_address: { value: '', type: 'text', name: '甲方地址/电话' },
        party_a_contact: { value: '', type: 'text', name: '甲方联系人' },
        party_a_add_date: { value: '', type: 'date', name: '甲方日期' },
        party_a_phone: { value: '', type: 'text', name: '甲方联系电话' },
      },
      party_b_data: {
        party_b_contact: { value: '', type: 'text', name: '乙方联系人' },
        party_b_phone: { value: '', type: 'text', name: '乙方联系电话' },
        add_date: { value: '', type: 'date', name: '乙方日期' },
        company: { value: '', type: 'text', name: '乙方账户名称' },
        bank: { value: '', type: 'text', name: '乙方开户银行' },
        account: { value: '', type: 'text', name: '乙方账户' },
      },
      order_data: [],
      pickerOptions: {
        // disabledDate(time) {
        //     return time.getTime() > Date.now();
        // },
      },
      companyList: [],
      op_reason: '',
      pickerOptionsMonth: {
        disabledDate (time) {
          return time.getTime() > new Date('2021-03-31 00:00:00');
        },
      },
      fileList: [],
      uploadFile: [],
      fileUrl: '',
      lookFlag: false,
      dataInfo: {},
      editFlag: false,
      reason: '',
      customer_name: '',
      order_list: {},
      partyBAccountList: [],
      customerList: []
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    var date = new Date();
    var party_date = date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : (date.getMonth() + 1)) + '-' + (date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate())
    this.party_a_data.party_a_add_date.value = party_date;
    this.party_b_data.add_date.value = party_date;
    if (this.userInfo.role_id == 15 || this.userInfo.role_id == 10 || (this.statement_status == 1 || this.statement_status == 2 || this.statement_status == 4)) {//判断是否可编辑
      this.editFlag = false
    } else {
      this.editFlag = true
    }
    if (this.statement_id) {//详情
      this.statementDetail()
    } else {
      this.addOrder()
    }
    if (this.type == 2) {
      this.getMcnList()
    } else {
      this.getCustomerList()
    }
    this.getPartyBAccountList()
  },
  methods: {
    party_a_change (value) {
      let data = this.customerList.filter((v) => {
        return this.type == 2 ? v.name == value : v.customer_name == value
      })[0]
      this.party_a_data.party_a_ein.value = data.party_a_ein
      this.party_a_data.party_a_account.value = data.party_a_account
      this.party_a_data.party_a_address.value = data.party_a_address
      this.customer_name = value
    },
    deleteOrder (index) {
      if (this.order_data.length == 1) {
        this.$message({
          message: '至少存在一个订单！',
          type: 'warning'
        })
        return
      }
      this.order_data.splice(index, 1)
    },
    addOrder () {
      this.order_data.push(JSON.parse(JSON.stringify(this.table_data)))
    },
    printDOM () {
      this.getPdf({ title: (this.party_a_data.party_a_name.value ? this.party_a_data.party_a_name.value : '') + '结算单', noScrollBar: true, invoice: false })
    },
    statementDetail () {//详情
      this.$loading(this.$loadingConfig)
      this.$axios.get(this.URL.BASEURL + this.URL.statementsComplement_detail, { params: { id: this.statement_id, isEdit: this.editFlag ? 1 : 0 } }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && (res.errno == '0' || res.errno == 0)) {
          var data = res.rst;
          this.dataInfo = data.account;
          this.uploadFile = data.account.files;
          if (this.editFlag) {//可编辑
            var obj = {}
            data.order.forEach((item, index) => {
              obj = JSON.parse(JSON.stringify(this.table_data));
              for (var i in item) {
                if (obj[i]) {
                  obj[i].value = item[i]
                }
              }
              this.order_data.push(obj)
            })
          } else {//不可编辑
            this.order_list = data.order
          }
          this.customer_name = this.dataInfo.customer_name
          for (var i in this.party_a_data) { this.party_a_data[i].value = data.account[i] }
          for (var i in this.party_b_data) { this.party_b_data[i].value = data.account[i] }
          this.fileList = [];
          if (data.account.files) {
            data.account.files.forEach((item, index) => {
              this.fileList.push({ name: item && item.split('/') && item.split('/')[item.split('/').length - 1] ? item.split('/')[item.split('/').length - 1] : '附件', url: item })
            });
          }
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    editStatement () {//提交
      var axios_order_data = [], arr = {}, flag = false;
      this.order_data.forEach((item) => {
        arr = {}
        for (var i in item) {
          arr[i] = item[i].value;
          if (!item[i].noMust && (item[i].value == '' || !item[i].value)) {
            this.$message({
              message: '请输入' + item[i].name,
              type: 'warning'
            })
            flag = true
            return
          }
        }
        axios_order_data.push(arr)
      })
      if (flag) { return }
      for (var i in this.party_a_data) {
        if (!this.party_a_data[i].value || this.party_a_data[i].value == '') {
          this.$message({
            message: '请输入' + this.party_a_data[i].name,
            type: 'warning'
          })
          return
        }
      }
      for (var i in this.party_b_data) {
        if (!this.party_b_data[i].value || this.party_b_data[i].value == '') {
          this.$message({
            message: '请输入' + this.party_b_data[i].name,
            type: 'warning'
          })
          return
        }
      }
      if (this.uploadFile.length == 0) {
        this.$message({
          message: '请上传附件',
          type: 'warning'
        })
        return
      }
      var axios_api = this.URL.statementsComplement_add;
      var params = {
        type: this.type,
        files: this.uploadFile,
        order_data: axios_order_data,
        customer_name: this.customer_name
      }
      if (this.dataInfo.verify_status == 3 || this.dataInfo.verify_status == 5) {
        axios_api = this.URL.statementsComplement_update;
        params = {
          id: this.statement_id,
          files: this.uploadFile,
          order_data: axios_order_data,
          customer_name: this.customer_name
        }
      }
      for (var i in this.party_a_data) { params[i] = this.party_a_data[i].value }
      for (var i in this.party_b_data) { params[i] = this.party_b_data[i].value }
      this.$loading(this.$loadingConfig)
      this.$axios.post(this.URL.BASEURL + axios_api, params).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && (res.errno == '0' || res.errno == 0)) {
          this.$alert('提交成功', '成功', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: action => {
              this.$emit('emit_refresh')
            }
          });
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    examineSubmit (status) {//审核
      if ((status == 3 || status == 5) && (!this.reason || this.reason == '')) {
        this.$message({
          message: '请输入审核原因',
          type: 'warning'
        })
        return
      }
      this.$loading(this.$loadingConfig)
      this.$axios.post(this.URL.BASEURL + this.URL.statementsComplement_verify, {
        id: this.statement_id,
        status: status,
        opinion: this.reason
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          this.$emit('emit_refresh')
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    clearNoNum ({ value, index, valueName, mainName }) {//判断只能输入纯数字或者小数点，及负整数
      var t = value.charAt(0);
      //先把非数字的都替换掉，除了数字和.
      value = value.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是.
      value = value.replace(/^\./g, "");
      //保证只有出现一个.而没有多个.
      value = value.replace(/\.{2,}/g, ".");
      //保证.只出现一次，而不能出现两次以上
      value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
      //如果第一位是负号，则允许添加   如果不允许添加负号 可以把这块注释掉
      if (t == '-') {
        value = '-' + value;
      }
      this[mainName][index][valueName].value = value
    },
    orderCancelClick () {
      this.$emit('cancelToast')
    },
    lookFile (data) {//查看文件
      this.fileUrl = data;
      // this.lookFlag = true
      let routeData = this.$router.resolve({
        path: '/lookFile?url=' + this.fileUrl,
      })
      this.$winopen(routeData.href)
    },
    downLoadFiles (data) {//下载
      var url = data.replace("[http://]|[https://]", window.location.protocol + '//');
      var doc_name = (url.split('/'))[url.split('/').length - 1]
      this.ajax(url, (xhr) => {
        this.downloadFile(xhr.response, doc_name)
      }, {
        responseType: 'blob'
      })
    },
    ajax (url, callback, options) {
      window.URL = window.URL || window.webkitURL
      var xhr = new XMLHttpRequest()
      xhr.open('get', url, true)
      if (options.responseType) {
        xhr.responseType = options.responseType
      }
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          callback(xhr)
        }
      }
      xhr.send()
    },
    downloadFile (content, filename) {
      var a = document.createElement('a')
      var blob = new Blob([content])
      var url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    },
    getPartyBAccountList () {
      this.$axios.get(this.URL.BASEURL + this.URL.partyBAccountList, {
        params: {
          page: 1,
          pagesize: 1000,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.partyBAccountList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    getMcnList () {//mcn机构全称配置
      this.$axios.get(this.URL.BASEURL + this.URL.mcnList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
        } else {
        }
      }).catch(() => {
      })
    },
    getCustomerList () {
      this.$axios.get(this.URL.BASEURL + this.URL.customerList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
        } else {
        }
      }).catch(() => {
      })
    },
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
.verifySpan {
  color: #5e5f6b;
  font-size: 14px;
}
#ImageExportDom {
  margin-top: -40px;
  padding: 20px;
}
.table_container {
  width: 100%;
  margin-top: 6px;
}
table {
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  tr {
    &:first-of-type {
      background: #f3e8e3;
      height: 33px;
    }
    td,
    th {
      border: 1px solid #ebeef4;
      padding: 2px 4px;
      // width: 16.6%;
      .input {
        width: 100%;
      }
    }
  }
}
.table_container2 {
  table {
    tr {
      td,
      th {
        padding: 6px 4px;
        width: auto;
        font-size: 13px;
        height: 30px;
      }
    }
  }
}
.bothSidesBox {
  .aParty {
    float: left;
    width: 49%;
    .title {
      color: #202652;
      font-size: 15px;
      line-height: 21px;
      font-weight: 500;
      margin-top: 20px;
    }
    .infoItem {
      margin: 10px 0;
      label {
        display: inline-block;
        width: 100px;
        color: #202652;
        font-size: 13px;
        line-height: 20px;
      }
      .inputDiv {
        color: #5e5f6b;
        font-size: 14px;
        line-height: 20px;
        display: inline-block;
      }
      .input {
        width: 300px;
        display: inline-block;
      }
    }
  }
}
.verify_opinion {
  font-size: 13px;
  color: #202652;
  padding: 10px 20px;
  label {
    vertical-align: top;
    width: 100px;
    display: inline-block;
  }
  .textarea {
    width: 80%;
  }
  .item {
    margin-top: 10px;
  }
}
.flexBox {
  display: flex;
  align-items: center;
}
.enclosure {
  color: #2c4a77;
  margin-bottom: 20px;
  display: inline-block;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
}
.titleBox {
  position: relative;
  padding-bottom: 20px;
  .title {
    font-size: 20px;
    line-height: 30px;
    font-weight: bold;
    text-align: center;
    color: #333;
  }
  .xlh {
    position: absolute;
    top: 10px;
    right: 20px;
    color: #202652;
    font-size: 14px;
  }
}
.add_icon {
  display: block;
  width: 20px;
  height: 20px;
  margin: 5px auto;
  cursor: pointer;
}
table {
  color: #383d64;
}
</style>
<style lang="scss">
.beforeApril .el-input--suffix .el-input__inner {
  padding-right: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/statements/add_statements.vue